// eslint-disable-next-line import/prefer-default-export
export const attribsWithoutClass = (attribs) => {
    const copy = Object.assign({}, attribs);
    delete copy.class;
    return copy;
};
